export default function Chevron({
  step,
  bgColor,
  textColor,
  isCurrentStage,
  isFirstStep,
  isFinalStep,
  glowClass,
}) {
  return (
    <div
      className={`flex-1 relative flex-shrink-0 
                  h-12 sm:h-14 md:h-16 lg:h-20 ${glowClass} group`}
    >
      {/* Chevron background */}
      <div
        className={`absolute inset-0 ${bgColor} ${
          isFirstStep
            ? "clip-chevron-rounded-left"
            : isFinalStep
            ? "clip-chevron-final-tail"
            : "clip-chevron"
        }`}
      ></div>

      {/* Label and Date (hidden on tablet & below) */}
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 
                   w-[90%] text-center leading-tight p-8
                   hidden lg:block"
      >
        <span
          className={`block text-[10px] xs:text-[11px] sm:text-xs md:text-sm 
                      font-bold ${textColor}`}
        >
          {step.label}
        </span>

        {step.formattedDate && step.formattedDate !== "-" && (
          <div
            className={`text-[8px] xs:text-[9px] sm:text-[10px] md:text-xs mt-1 
                        ${textColor}`}
          >
            {step.formattedDate}

            {isCurrentStage && step.daysBetween !== null && (
              <>
                <span className={`mx-1 ${textColor}`}>•</span>
                <span>
                  {step.daysBetween === 0
                    ? "today"
                    : `${step.daysBetween} ${
                        step.daysBetween === 1
                          ? "day spent here"
                          : "days spent here"
                      }`}
                </span>
              </>
            )}
          </div>
        )}
      </div>

      {/* Tooltip for small screens */}
      <div
        className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2
                   px-2 py-1 text-xs text-white bg-gray-800 rounded 
                   opacity-0 pointer-events-none 
                   group-hover:opacity-100 group-hover:pointer-events-auto 
                   transition-opacity duration-200
                    whitespace-nowrap z-50"
      >
        {step.label}
        {step.formattedDate && step.formattedDate !== "-" && (
          <>
            <br />
            {step.formattedDate}
          </>
        )}
      </div>
    </div>
  );
}
